import React, { useEffect, useState } from "react";
import { Redirect } from "react-router-dom";
import { withLocalize } from "react-localize-redux";
import translations from "../../translations/landing.json";
import { SearchBox } from "wallet-elementkit/dist/components";
import "../../styles/landing/landing.scss";
import "../../styles/app.scss";
import mixpanel from "mixpanel-browser";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { getMasterConfig } from "wallet-elementkit/dist/constants/master";

const Landing = (props) => {
	const history = useHistory();
	const config = getMasterConfig();
	const [redir, setRedir] = useState(null);
	const [isCustomization, setIsCustomization] = useState(false);

	useEffect(() => {
		props.addTranslation(translations);
		const search = props.location.search;
		const isCustomization =
			new URLSearchParams(search).get("customization") === "true";
		setIsCustomization(isCustomization);
	}, []);

	if (redir != null)
		return (
			<Redirect
				push
				to={
					props.activeLanguage
						? `/${props.activeLanguage.code}/${redir}`
						: `/${redir}`
				}
			/>
		);

	return (
		<div
			className={`flex-column main ${isCustomization && "no-pointer-event"}`}
		>
			<div
				className="flex-column search-div"
				style={{
					backgroundColor:
						config.landingPageSearchSectionBackgroundColor ||
						config.primaryColor,
				}}
			>
				<span
					className="cred-verif-text"
					style={{
						color: `${config.headerColor || "#000E27"}`,
					}}
				>
					{config.headerText ||
						props.translate("credentialVerification").toString()}
				</span>
				<SearchBox
					historyPush={history.push}
					isDynamicColored={true}
					activeLanguage={props.activeLanguage}
					translate={props.translate}
					addTranslation={props.addTranslation}
					isLandingPage
					isMobile={false}
					mixpanel={mixpanel}
				/>
			</div>
		</div>
	);
};

export default withLocalize(Landing);
